export default __webpack_public_path__ + "static/media/icon-qrcode-list.e792eb83.svg";